/* global */
let polls = {}

const addPoll = (id, poll) => {
  workerPolls.polls[id] = poll
}

const resetPoll = () => {
  polls.polls = {}
}

const workerPolls = {
  resetPoll,
  addPoll,
  polls
}

module.exports = workerPolls